
export const sFechaPublicacion = '2023-11-01T16:17:12.6423759-06:00';
export const sVersion = 'vSlider0.1.11011617';
            